export const buildServicesStatusData = services => ([{
    name: 'common:telephony',
    status: services.telephony
}, {
    name: 'common:information',
    status: services.data
}, {
    name: 'common:dhcp',
    status: services.dhcp
}, {
    name: 'common:snmp',
    status: services.snmp
}, {
    name: 'common:ntp',
    status: services.ntp
}, {
    name: 'common:messaging',
    status: services.im
}]);
